import clsx from 'clsx'

import type {
  BuildingBlockKeyFactsRepeaterItemTableRepeaterProps,
  RoundtripKeyFactsRepeaterItemTableRepeaterProps,
} from '@typings'
import { RaRichText, RaTypography } from '@components/core/index.core'
import { SPOTLER_IDS } from '@constants/spotler.constants'
import { unescapeHTML } from '@utilities/helpers/unescape-html.helpers'

import styles from './ra-keyfact-without-icon.module.scss'

type KeyfactsRepeaterProps =
  | BuildingBlockKeyFactsRepeaterItemTableRepeaterProps
  | RoundtripKeyFactsRepeaterItemTableRepeaterProps

interface RaKeyfactWithoutIconProps {
  item: KeyfactsRepeaterProps
  directionMobile?: 'row' | 'column'
}

export const RaKeyfactWithoutIcon = ({
  item,
  directionMobile = 'column',
}: RaKeyfactWithoutIconProps) => {
  const keyfact = unescapeHTML(item.text)
  const fixedTitle = item.title.trim()
  const title = fixedTitle ? unescapeHTML(fixedTitle) + ':' : ''

  return (
    <li
      className={clsx(styles['keyfact'], directionMobile === 'row' && styles['keyfact--row'])}
      data-spotler-id={SPOTLER_IDS.keyfact}>
      <RaTypography
        component="span"
        weight="bold">
        {title}
      </RaTypography>
      <div>
        <RaRichText content={keyfact} />
        {item.extraLines?.map((detail, i) => (
          <RaRichText
            key={i}
            content={unescapeHTML(detail)}
          />
        ))}
      </div>
    </li>
  )
}
